export default "__VITE_ASSET__BmCn4O36__"